import { reactive } from 'vue'

export const hotelOptions = reactive({})
